module.exports = __webpack_public_path__ + "img/erCode.ba647601.png";